import styled from "@emotion/styled";

export interface TokenSelectedProps {}

export const SelectedToken = styled.span<TokenSelectedProps>`
  margin-left: 8px;
  margin-right: 4px;
  font-size: 20px;
  font-weight: 500;
  color: white !important;
  display: flex;
  align-items: center;
`;
